import { getInitialsAvatar, getResolvedAvatar } from './avatarCache';

export const getPlayerAvatar = (param1, param2) => {
  let players = [];
  let name = '';

  if (Array.isArray(param1)) {
    players = param1;
    name = param2;
  } else if (Array.isArray(param2)) {
    players = param2;
    name = param1;
  } else {
    name = typeof param1 === 'string' ? param1 : (typeof param2 === 'string' ? param2 : '');
  }

  const safePlayers = Array.isArray(players) ? players : [];
  const player = safePlayers.find((p) => p && p.name === name);

  // Locally cached copy of the photo when we have one; otherwise local initials (no network needed)
  return player?.photoUrl ? getResolvedAvatar(player.photoUrl) : getInitialsAvatar(name);
};
